import { put, takeEvery, select } from 'redux-saga/effects';
import { postWithToken, getWithToken } from '../../../api/network';
import {
  appNotify,
  setSelectedGroupIsLoading,
  copyShapesForGroup,
  setSelectedGroupId,
  setMapIsLoading,
  setSelectedModule
} from '../../../store/actions';
import { selectedModuleSelector } from 'store/selectors'; 

export function* copyShapesForGroupSaga() {
  yield takeEvery(copyShapesForGroup, function* ({ payload }) {
    try {
      yield put(setSelectedGroupIsLoading(true));
      yield put(setMapIsLoading(true, 'COPY', 'Copying Shapes...'));

      yield postWithToken(`/api/assumptions/shapes/copy`, payload);

      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(false, 'COPY'));

      yield put(appNotify('Shapes copied', 'success'));
      yield put(setSelectedGroupId(payload.groupId));

      const selectedModule = yield select(selectedModuleSelector); 
      const moduleUrl = `/api/assumptions/modules/${selectedModule.moduleId}`; 
      const res = yield getWithToken(moduleUrl); 
      const data = yield res.json(); 
 
      yield put(setSelectedModule(data)); 
    } catch (error) {
      yield put(appNotify(`Failed to copy shapes: ${error.message}`, 'error'));
      yield put(setSelectedGroupIsLoading(false));
      yield put(setMapIsLoading(false, 'COPY'));
    }
  });
}
